import React from "react";
import { MdCurrencyRupee, MdLocationOn } from "react-icons/md";

// Zone-to-zone matrix in the onboarding prototype's style: grey "origin \ dest" corner, orange zone
// headers with a pin, dotted row labels. Read-only by default; with `editable` every cell is an
// input and cells that differ from the current value (`values`) are highlighted.
const RateMatrix = ({ title, subtitle, zones, values, unit, editable, draft = {}, onChange, onZoneClick, icon: Icon = MdCurrencyRupee }) => (
  <div className="ob_card ob_matrix_card">
    <div className="ob_matrix_title">
      <h5>
        <Icon /> {title}
      </h5>
      <p>{subtitle}</p>
    </div>
    <div className="ob_matrix_wrap">
      <table className="ob_matrix">
        <thead>
          <tr>
            <th className="corner">
              <span>Origin \ Dest</span>
              <strong>Zone</strong>
            </th>
            {zones.map((z) => (
              <th key={z.id} className="zone_head">
                <button type="button" onClick={() => onZoneClick && onZoneClick(z)}>
                  <MdLocationOn /> {z.name}
                </button>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {zones.map((from) => (
            <tr key={from.id}>
              <th className="row_head">
                <span className="dot" /> {from.name}
              </th>
              {zones.map((to) => {
                const key = `${from.id}-${to.id}`;
                const current = values[key];
                const shown = editable && draft[key] !== undefined ? draft[key] : current ?? "";
                const changed = editable && draft[key] !== undefined && String(draft[key]) !== String(current ?? "");
                return (
                  <td key={to.id}>
                    {editable ? (
                      <>
                        <input
                          className={changed ? "changed" : ""}
                          inputMode="decimal"
                          value={shown}
                          onChange={(e) => onChange(key, e.target.value.replace(/[^\d.]/g, ""))}
                        />
                        {changed && <small className="was">was {current}</small>}
                      </>
                    ) : (
                      <span className="cell">{current === undefined || current === "" ? "—" : `${current}${unit || ""}`}</span>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default RateMatrix;
